import React from "react";
import "./Footer.css";

function Footer() {
  const currentYear = new Date().getFullYear();

  const socialLinks = [
    // {
    //   name: "Instagram",
    //   icon: "📸",
    //   url: "https://www.instagram.com/da_cakes_store?igsh=cGs4Nzg0ZTFmamYw",
    //   username: "da_cakes_store"
    // },
    {
      name: "Telegram",
      icon: "✈️",
      url: "https://t.me/militr_am",
      phone: "+7 (985) 200-37-21"
    },
    {
      name: "Telegram",
      icon: "✈️",
      url: "https://t.me/da_cakes",
      phone: "da_cakes_store"
    },
  ];

  const handleScroll = (e, href) => {
    if (href.startsWith('#')) {
      e.preventDefault();
      const element = document.querySelector(href);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  return (
    <footer className="footer">
      {/* Декоративные элементы */}
      <div className="footer-decoration">
        <div className="decoration-circle"></div>
        <div className="decoration-dots"></div>
      </div>

      <div className="footer-container">
        {/* Основной контент футера */}
        <div className="footer-main">
          {/* Лого и описание */}
          <div className="footer-brand">
            <div className="brand-logo">
              <span className="logo-icon">🍰</span>
              <h2 className="logo-text">da_cakes_store</h2>
            </div>
            <p className="brand-description">
              Авторские торты и десерты с любовью для ваших праздников
            </p>
          </div>

          {/* Социальные сети и контакты */}
          <div className="footer-social">
            <h3 className="footer-title">Свяжитесь со мной</h3>
            <div className="social-links">
              {socialLinks.map((social, index) => (
                <a
                  key={index}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-link"
                >
                  <span className="social-icon">{social.icon}</span>
                  <div className="social-info">
                    <span className="social-name">{social.name}</span>
                    <span className="social-value">
                      {social.username || social.phone}
                    </span>
                  </div>
                </a>
              ))}
            </div>
          </div>

          {/* Быстрые ссылки */}
          <div className="footer-links">
            <h3 className="footer-title">Навигация</h3>
            <ul className="links-list">
              <li><a href="#About" className="footer-link" onClick={(e) => handleScroll(e, "#About")}>Почему я</a></li>
              <li><a href="#Work" className="footer-link" onClick={(e) => handleScroll(e, "#Work")}>Работы</a></li>
              <li><a href="#Price" className="footer-link" onClick={(e) => handleScroll(e, "#Price")}>Прайс</a></li>
              <li><a href="#Before" className="footer-link" onClick={(e) => handleScroll(e, "#Before")}>Вопросы</a></li>
              <li><a href="#Feedback" className="footer-link" onClick={(e) => handleScroll(e, "#Feedback")}>Отзывы</a></li>
              <li><a href="#Order" className="footer-link" onClick={(e) => handleScroll(e, "#Order")}>Заказать</a></li>
            </ul>
          </div>
        </div>

        {/* Нижняя часть футера */}
        <div className="footer-bottom">
          <div className="footer-legal">
            <div className="copyright">
              <span className="copyright-icon">©</span>
              <span>{currentYear} da_cakes_store. Все права защищены</span>
            </div>
            <div className="legal-links">
              <a href="/policy" className="legal-link">Политика конфиденциальности</a>

            </div>
          </div>
          
          <div className="developer">
            <span className="developer-text">website from:</span>
            <a
              href="https://t.me/maksim_medvedew"
              target="_blank"
              rel="noopener noreferrer"
              className="developer-link"
            >
              <span className="developer-icon">👨‍💻</span>
              @maksim_medvedew
              <span className="link-arrow">→</span>
            </a>
          </div>
        </div>
      </div>

      {/* Кнопка "Наверх" */}
      <button 
        className="back-to-top"
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        aria-label="Наверх"
      >
        <span className="arrow-up">↑</span>
      </button>
    </footer>
  );
}

export default Footer;